import RoutePath from 'App/RoutePath';
import useFeatureFlag, { FEATURE_FLAGS } from 'flags/useFeatureFlag';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const useRedirectIfVerificationFlowDisabled = () => {
  const history = useHistory();
  const newRegistrationFlowEnabled = useFeatureFlag(
    FEATURE_FLAGS.ENTERPRISE_READINESS_SHOW_EMAIL_FIRST_VERIFICATION,
  );

  useEffect(() => {
    if (
      newRegistrationFlowEnabled !== undefined &&
      !newRegistrationFlowEnabled
    ) {
      history.push(RoutePath.Login);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newRegistrationFlowEnabled]);
};
